import { ReportRoleEnum } from "@/lib/enum/ReportRole.enum";
import { IsFilterable, Filter } from "@/lib/filterable";
import { MrfiktivAccidentDetailsGen, MrfiktivCreateAccidentDetailsDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import { IAddressWithGeo, AddressWithGeo } from "@/models/address.entity";
import { formatAsFullDateAndFullHour } from "@/lib/utility/date-helper";

@IsFilterable
class AccidentDetailsBase implements MrfiktivAccidentDetailsGen {
  role: ReportRoleEnum;
  date: string;

  get dateFormable(): string {
    if (!this.date) {
      return "";
    }
    return formatAsFullDateAndFullHour(new Date(this.date).getTime());
  }
  set dateFormable(date: string) {
    if (date) {
      this.date = new Date(date).toISOString();
    }

    this.date = date;
  }

  comment?: string | undefined;
  address: IAddressWithGeo;

  constructor(accidentDetails?: Partial<MrfiktivAccidentDetailsGen>) {
    this.role = (accidentDetails?.role ?? ReportRoleEnum.UNCLEAR) as ReportRoleEnum;
    this.date = accidentDetails?.date ? new Date(accidentDetails?.date).toISOString() : new Date().toISOString();
    this.comment = accidentDetails?.comment;
    this.address = new AddressWithGeo(accidentDetails?.address);
  }

  /**
   *
   */
  get dto(): MrfiktivCreateAccidentDetailsDtoGen {
    return {
      role: this.role,
      date: new Date(this.date).toISOString(),
      comment: this.comment,
      address: this.address ?? null
    };
  }
}

type IAccidentDetails = AccidentDetailsBase;
const AccidentDetails = Filter.createForClass(AccidentDetailsBase);

export { AccidentDetails, IAccidentDetails };
